/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Disabled_Websites_Section_TitleInputs */

const en_disabled_websites_section_title = /** @type {(inputs: Disabled_Websites_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Websites with Limited Compatibility`)
};

const es_disabled_websites_section_title = /** @type {(inputs: Disabled_Websites_Section_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitios con compatibilidad limitada`)
};

/**
* | output |
* | --- |
* | "Websites with Limited Compatibility" |
*
* @param {Disabled_Websites_Section_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_section_title = /** @type {((inputs?: Disabled_Websites_Section_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Section_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_section_title(inputs)
	return en_disabled_websites_section_title(inputs)
});